import React from 'react';
import { KanbanAdminProvider } from '../contexts/KanbanAdminContext';
import KanbanAdminBoard from '../components/admin/KanbanAdminBoard';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const KanbanAdminPage: React.FC = () => {
  const { usuario } = useAuth();
  
  // Verificar se o usuário é admin
  if (!usuario || usuario.tipo !== 'admin') {
    return <Navigate to="/kanban" replace />;
  }

  return (
    <KanbanAdminProvider>
      <div className="p-4">
        <KanbanAdminBoard />
      </div>
    </KanbanAdminProvider>
  );
};

export default KanbanAdminPage;
